import { useCallback, useState } from 'react';

export type StudioViewMode = 'single' | 'canvas';

const STORAGE_KEY = 'tinct-studio-view-mode';

/**
 * The studio's render mode — single viewport or the multi-breakpoint canvas.
 * Persisted so the choice survives navigation between the edit step, the
 * studio and reloads.
 */
export function useStudioViewMode(): [StudioViewMode, (mode: StudioViewMode) => void] {
  const [mode, setMode] = useState<StudioViewMode>(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'canvas' ? 'canvas' : 'single';
    } catch {
      return 'single';
    }
  });

  const set = useCallback((next: StudioViewMode) => {
    setMode(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // Private-mode storage failures just lose persistence.
    }
  }, []);

  return [mode, set];
}
